const BalanceAssetEN = Object.freeze({
    'tab-title.accountSummary': 'Account Summary',
    'tab-title.assetsManagement': 'Assets Management',
    'tab-title.transactionDetails': 'Transaction Details',
    'tab-title.report': 'Report',

    // Account Balance Overview
    'account-summary.balance.title': 'Account Balance Overview',
    'account-summary.balance.caption':
        'Please choose an account to preview the transaction details and more',
    'account-summary.balance.currencySelection.withdrawal': 'Withdrawal',
    'account-summary.balance.currencySelection.totalCashBalance':
        'Total Cash Balance',
    'account-summary.balance.currencySelection.freeCashBalance':
        'Free Cash Balance',
    'account-summary.balance.currencySelection.outstandingAdvancement':
        'Outstanding Advancement',
    'account-summary.balance.currencySelection.pendingWithdraws':
        'Pending Withdraws',
    'account-summary.balance.currencySelection.purchasedAssets':
        'Purchased Assets',
    'account-summary.balance.currencySelection.outstandingNetGain':
        'Outstanding Net Gain',
    'account-summary.balance.currencySelection.expectedGrossGain':
        'Expected Gross Gain',
    'account-summary.balance.currencySelection.expectedFunderCommission':
        'Expected Funder Commission',
    'account-summary.balance.currencySelection.receivables': 'Receivables',
    'account-summary.balance.withdrawal': 'Withdrawal',
    'account-summary.balance.withdrawalModal.title': 'New Withdrawal Request',
    'account-summary.balance.withdrawalModal.caption':
        'Please select the withdrawal account and input the withdrawal amount, our team will process your requests within 1 working day.',
    'account-summary.balance.withdrawalModal.withdrawalAccount':
        'Withdrawal Account',
    'account-summary.balance.withdrawalModal.availableBalance':
        'Available Balance',
    'account-summary.balance.withdrawalModal.withdrawalAmount':
        'Withdrawal Amount',
    'account-summary.balance.withdrawalModal.error.emptyInput':
        'Please input amount',
    'account-summary.balance.withdrawalModal.error.inputLessThanOne':
        'Withdrawal amount must be greater than 0',
    'account-summary.balance.withdrawalModal.error.inputGreaterThanBalance':
        'Withdrawal amount must be less than free cash balance',
    'account-summary.balance.withdrawalModal.error.nullSelectAccount':
        'Please select an account',

    // Transaction Records
    'account-summary.transaction-record.title': 'Transaction Records',
    'account-summary.transaction-record.txnDate': 'Transaction Date',
    'account-summary.transaction-record.txnType': 'Transaction Type',
    'account-summary.transaction-record.assetNo': 'Asset No.',
    'account-summary.transaction-record.txnAmount': 'Transaction Amount',
    'account-summary.transaction-record.accountBalance': 'Account Balance',
    'account-summary.transaction-record.closingBalance': 'Closing Balance',
    'account-summary.transaction-record.placeholder.txnType':
        'Transaction Type',
    'account-summary.transaction-record.csv.txnType': 'Transaction Type',
    'account-summary.transaction-record.csv.assetNo': 'Asset No.',
    'account-summary.transaction-record.csv.currency': 'Currency',
    'account-summary.transaction-record.csv.amount': 'Amount',
    'account-summary.transaction-record.csv.accountBalance': 'Account Balance',
    'account-summary.transaction-record.csv.txnDate': 'Transaction Date',
    'account-summary.transaction-record.txnType.bankChargeUndertake': 'Bank charge undertake by Qupital',
    'account-summary.transaction-record.txnType.inExchangeDeposit': 'Exchange Deposit',
    'account-summary.transaction-record.txnType.gainAmountAdvanced':
        'Gain amount advanced',
    'account-summary.transaction-record.txnType.platformFee': 'Platform fee',
    'account-summary.transaction-record.txnType.gain': 'Gain',
    'account-summary.transaction-record.txnType.bankCharge': 'Bank charge',
    'account-summary.transaction-record.txnType.settlement': 'Settlement',
    'account-summary.transaction-record.txnType.auctionRecoveryAmount':
        'Asset recovery amount',
    'account-summary.transaction-record.txnType.depositRounding':
        'Deposit rounding',
    'account-summary.transaction-record.txnType.deposit': 'Deposit',
    'account-summary.transaction-record.txnType.withdraw': 'Withdrawal',
    'account-summary.transaction-record.txnType.spvServiceFee': 'SPV Service Fee',

    // Deposit Withdrawal Requests
    'account-summary.deposit-withdrawal-request.title':
        'Deposit / Withdrawal Requests',
    'account-summary.deposit-withdrawal-request.requestDate': 'Request Date',
    'account-summary.deposit-withdrawal-request.requestType': 'Request Type',
    'account-summary.deposit-withdrawal-request.requestType.withdraw':
        'Withdraw',
    'account-summary.deposit-withdrawal-request.requestType.deposit': 'Deposit',
    'account-summary.deposit-withdrawal-request.requestType.inExchangeDeposit':
        'Exchange Deposit',
    'account-summary.deposit-withdrawal-request.requestType.spvServiceFee': 'SPV Service Fee',
    'account-summary.deposit-withdrawal-request.requestAmount':
        'Request Amount',
    'account-summary.deposit-withdrawal-request.status': 'Status',
    'account-summary.deposit-withdrawal-request.status.approved': 'Approved',
    'account-summary.deposit-withdrawal-request.status.rejected': 'Rejected',
    'account-summary.deposit-withdrawal-request.status.pending': 'Pending',
    'account-summary.deposit-withdrawal-request.completeDate': 'Complete Date',
    'account-summary.deposit-withdrawal-request.placeholder.txnType':
        'Transaction Type',
    'account-summary.deposit-withdrawal-request.csv.requestDate':
        'Request Date',
    'account-summary.deposit-withdrawal-request.csv.requestType':
        'Request Type',
    'account-summary.deposit-withdrawal-request.csv.requestAmount':
        'Request Amount',
    'account-summary.deposit-withdrawal-request.csv.status': 'Status',
    'account-summary.deposit-withdrawal-request.csv.completeDate':
        'Complete Date',

    // Asset Portfolio Overview
    'assetsManagement.portfolio.title': 'Asset Portfolio Overview',
    'assetsManagement.portfolio.caption':
        'Visualize your Asset Portfolio by seller, which may help you to diversify risk and make better decision on assets acquisition.',
    'assetsManagement.portfolio.message':
        'If more than one currencies have been selected, all assets shown in the chart will convert to USD.',
    'assetsManagement.portfolio.csv.sellerNo': 'Seller No.',
    'assetsManagement.portfolio.csv.currency': 'Currency',
    'assetsManagement.portfolio.csv.amount': 'Amount',

    // Asset - Awaiting Repayment
    'assetsManagement.awaiting-repayment.title': 'Asset - Awaiting Repayment',
    'assetsManagement.awaiting-repayment.assetNumber': 'Asset Number',
    'assetsManagement.awaiting-repayment.advanceAmount': 'Advance Amount',
    'assetsManagement.awaiting-repayment.currency': 'Currency',
    'assetsManagement.awaiting-repayment.credit-enhancementList': 'Credit Enhancement',
    'assetsManagement.awaiting-repayment.sellerNo': 'Seller No.',
    'assetsManagement.awaiting-repayment.netGain': 'Net Gain',
    'assetsManagement.awaiting-repayment.receivedNetGain': 'Received Net Gain',
    'assetsManagement.awaiting-repayment.outstandingNetGain': 'Outstanding Net Gain',
    'assetsManagement.awaiting-repayment.netReturn': 'Net Return (% p.a.)',
    'assetsManagement.awaiting-repayment.advanceDate': 'Advance Date',
    'assetsManagement.awaiting-repayment.lateDays': 'Late day',
    'assetsManagement.awaiting-repayment.status': 'Status',
    'assetsManagement.awaiting-repayment.subAssetNo': 'Sub-Asset No.',
    'assetsManagement.awaiting-repayment.debtDuration': 'Debt Duration',
    'assetsManagement.awaiting-repayment.dueDate': 'Due Date',
    'assetsManagement.awaiting-repayment.csv.assetNo': 'Asset No.',
    'assetsManagement.awaiting-repayment.csv.sellerNo': 'Seller No.',
    'assetsManagement.awaiting-repayment.csv.credit-enhancement': 'Credit Enhancement',
    'assetsManagement.awaiting-repayment.csv.obligorName': 'Obligor',
    'assetsManagement.awaiting-repayment.csv.currency': 'Currency',
    'assetsManagement.awaiting-repayment.csv.advanceAmount': 'Advanced Amount',
    'assetsManagement.awaiting-repayment.csv.grossGain': 'Gross Gain',
    'assetsManagement.awaiting-repayment.csv.outstandingGrossGain': 'Outstanding Gross Gain',
    'assetsManagement.awaiting-repayment.csv.qupitalFee': 'Funder Commission',
    'assetsManagement.awaiting-repayment.csv.netGain': 'Net Gain',
    'assetsManagement.awaiting-repayment.csv.receivedNetGain': 'Received Net Gain',
    'assetsManagement.awaiting-repayment.csv.outstandingNetGain': 'Outstanding Net Gain',
    'assetsManagement.awaiting-repayment.csv.grossReturn':
        'Gross Return (% p.a.)',
    'assetsManagement.awaiting-repayment.csv.netReturn': 'Net Return (% p.a.)',
    'assetsManagement.awaiting-repayment.csv.advanceDate': 'Advanced Date',
    'assetsManagement.awaiting-repayment.csv.dueDate': 'Due Date',
    'assetsManagement.awaiting-repayment.csv.remittedDate': 'Fully Remitted Date',
    'assetsManagement.awaiting-repayment.csv.lostDeclarationDate':
        'Lost Declaration Date',
    'assetsManagement.awaiting-repayment.csv.recoverAmount': 'Recovery Amount',
    'assetsManagement.awaiting-repayment.csv.lateDays': 'Late Day (days)',
    'assetsManagement.awaiting-repayment.csv.debtDuration': 'Duration (day(s))',
    'assetsManagement.awaiting-repayment.csv.isInsured': 'Insured Invoice',
    'assetsManagement.awaiting-repayment.csv.isObligorNotified':
        'Obligor Notification',
    'assetsManagement.awaiting-repayment.csv.status': 'Status',
    'assetsManagement.awaiting-repayment.tooltip.funder-flow-control': 'Fund Flow Control',
    'assetsManagement.awaiting-repayment.tooltip.inventory-control': 'Inventory Control',
    'assetsManagement.awaiting-repayment.remitted-amount': 'Remitted Amount',
    'assetsManagement.awaiting-repayment.outstanding-amount': 'Outstanding Amount',
    'assetsManagement.awaiting-repayment.csv.remitted-amount': 'Remitted Amount',
    'assetsManagement.awaiting-repayment.csv.outstanding-amount': 'Outstanding Amount',

    // Asset - Completed Repayment
    'assetsManagement.completed-repayment.title': 'Asset - All',
    'assetsManagement.completed-repayment.assetNumber': 'Asset Number',
    'assetsManagement.completed-repayment.advanceAmount': 'Advance Amount',
    'assetsManagement.completed-repayment.currency': 'Currency',
    'assetsManagement.completed-repayment.credit-enhancementList': 'Credit Enhancement',
    'assetsManagement.completed-repayment.sellerNo': 'Seller No.',
    'assetsManagement.completed-repayment.netGain': 'Net Gain',
    'assetsManagement.completed-repayment.receivedNetGain': 'Received Net Gain',
    'assetsManagement.completed-repayment.outstandingNetGain': 'Outstanding Net Gain',
    'assetsManagement.completed-repayment.netReturn': 'Net Return (% p.a.)',
    'assetsManagement.completed-repayment.advanceDate': 'Advance Date',
    'assetsManagement.completed-repayment.remittedDate': 'Fully Remitted Date',
    'assetsManagement.completed-repayment.remittance.remittedDate': 'Remitted Date',
    'assetsManagement.completed-repayment.lateDays': 'Late day',
    'assetsManagement.completed-repayment.status': 'Status',
    'assetsManagement.completed-repayment.subAssetNo': 'Sub-Asset No.',
    'assetsManagement.completed-repayment.debtDuration': 'Debt Duration',
    'assetsManagement.completed-repayment.dueDate': 'Due Date',
    'assetsManagement.completed-repayment.remittance': 'Remittance',
    'assetsManagement.completed-repayment.detail': 'Detail',
    'assetsManagement.completed-repayment.principalAmount': 'Principal Amount',
    'assetsManagement.completed-repayment.csv.assetNo': 'Asset No.',
    'assetsManagement.completed-repayment.csv.sellerNo': 'Seller No.',
    'assetsManagement.completed-repayment.csv.credit-enhancement': 'Credit Enhancement',
    'assetsManagement.completed-repayment.csv.obligorName': 'Obligor',
    'assetsManagement.completed-repayment.csv.currency': 'Currency',
    'assetsManagement.completed-repayment.csv.advanceAmount': 'Advanced Amount',
    'assetsManagement.completed-repayment.csv.principalAmount': 'Principal Amount',
    'assetsManagement.completed-repayment.csv.grossGain': 'Gross Gain',
    'assetsManagement.completed-repayment.csv.qupitalFee': 'Funder Commission',
    'assetsManagement.completed-repayment.csv.netGain': 'Net Gain',
    'assetsManagement.completed-repayment.csv.receivedNetGain': 'Received Net Gain',
    'assetsManagement.completed-repayment.csv.outstandingNetGain': 'Outstanding Net Gain',
    'assetsManagement.completed-repayment.csv.grossReturn':
        'Gross Return (% p.a.)',
    'assetsManagement.completed-repayment.csv.netReturn': 'Net Return (% p.a.)',
    'assetsManagement.completed-repayment.csv.advanceDate': 'Advanced Date',
    'assetsManagement.completed-repayment.csv.dueDate': 'Due Date',
    'assetsManagement.completed-repayment.csv.remittedDate': 'Fully Remitted Date',
    'assetsManagement.completed-repayment.csv.remittance.remittedDate': 'Remitted Date',
    'assetsManagement.completed-repayment.csv.lostDeclarationDate':
        'Lost Declaration Date',
    'assetsManagement.completed-repayment.csv.recoverAmount': 'Recovery Amount',
    'assetsManagement.completed-repayment.csv.lateDays': 'Late Day (days)',
    'assetsManagement.completed-repayment.csv.debtDuration':
        'Duration (day(s))',
    'assetsManagement.completed-repayment.csv.isInsured': 'Insured Invoice',
    'assetsManagement.completed-repayment.csv.isObligorNotified':
        'Obligor Notification',
    'assetsManagement.completed-repayment.csv.status': 'Status',
    'assetsManagement.completed-repayment.csv.remitted-amount': 'Remitted Amount',
    'assetsManagement.completed-repayment.csv.outstanding-amount': 'Outstanding Amount',
    'assetsManagement.completed-repayment.tooltip.funder-flow-control': 'Fund Flow Control',
    'assetsManagement.completed-repayment.tooltip.inventory-control': 'Inventory Control',
    'assetsManagement.completed-repayment.remitted-amount': 'Remitted Amount',
    'assetsManagement.completed-repayment.outstanding-amount': 'Outstanding Amount',
    'assetsManagement.live-asset.title': 'Asset - Live',

    // Report
    'assetsManagement.statement.title': 'Statement',
    'assetsManagement.statement.select-date-range': 'Select Date Range',
});

const BalanceAsset_ZH_TW = Object.freeze({
    'tab-title.accountSummary': '帳戶摘要',
    'tab-title.assetsManagement': '資產管理',
    'tab-title.transactionDetails': '交易明細',
    'tab-title.report': '報告',

    // Account Balance Overview
    'account-summary.balance.title': '帳戶結餘概覽',
    'account-summary.balance.caption': '請選擇帳戶以查看交易詳情',
    'account-summary.balance.currencySelection.withdrawal': '提款',
    'account-summary.balance.currencySelection.totalCashBalance': '總現金結餘',
    'account-summary.balance.currencySelection.freeCashBalance': '可用現金結餘',
    'account-summary.balance.currencySelection.outstandingAdvancement':
        '未結清匯款',
    'account-summary.balance.currencySelection.pendingWithdraws': '待提款',
    'account-summary.balance.currencySelection.purchasedAssets': '已購買資產',
    'account-summary.balance.currencySelection.outstandingNetGain': '預期淨收益',
    'account-summary.balance.currencySelection.expectedGrossGain': '預期收益',
    'account-summary.balance.currencySelection.expectedFunderCommission':
        '預期佣金',
    'account-summary.balance.currencySelection.receivables': '應收帳款',
    'account-summary.balance.withdrawal': '提款',
    'account-summary.balance.withdrawalModal.title': '建立提款要求',
    'account-summary.balance.withdrawalModal.caption':
        '請選擇提款帳戶及輸入提款金額，我們會在一個工作天內處理您的要求',
    'account-summary.balance.withdrawalModal.withdrawalAccount': '提款帳戶',
    'account-summary.balance.withdrawalModal.availableBalance': '可用結餘',
    'account-summary.balance.withdrawalModal.withdrawalAmount': '提款金額',
    'account-summary.balance.withdrawalModal.error.emptyInput':
        '請輸入提款金額',
    'account-summary.balance.withdrawalModal.error.inputLessThanOne':
        '提款金額不能少於 0',
    'account-summary.balance.withdrawalModal.error.inputGreaterThanBalance':
        '提款額不能大於可用結餘',
    'account-summary.balance.withdrawalModal.error.nullSelectAccount':
        '請選擇提款帳戶',

    // Transaction Records
    'account-summary.transaction-record.title': '交易記錄',
    'account-summary.transaction-record.txnDate': '交易日期',
    'account-summary.transaction-record.txnType': '交易項目',
    'account-summary.transaction-record.assetNo': '資產編號',
    'account-summary.transaction-record.txnAmount': '交易金額',
    'account-summary.transaction-record.accountBalance': '戶口結餘',
    'account-summary.transaction-record.closingBalance': '期末結餘',
    'account-summary.transaction-record.placeholder.txnType': '交易項目',
    'account-summary.transaction-record.csv.txnType': '交易項目',
    'account-summary.transaction-record.csv.assetNo': '資產編號',
    'account-summary.transaction-record.csv.currency': '貨幣',
    'account-summary.transaction-record.csv.amount': '金額',
    'account-summary.transaction-record.csv.accountBalance': '戶口結餘',
    'account-summary.transaction-record.csv.txnDate': '交易日期',
    'account-summary.transaction-record.txnType.bankChargeUndertake': '代付銀行手續費',
    'account-summary.transaction-record.txnType.inExchangeDeposit': '外幣轉換',
    'account-summary.transaction-record.txnType.gainAmountAdvanced': '投標本金',
    'account-summary.transaction-record.txnType.platformFee': '平台管理費',
    'account-summary.transaction-record.txnType.gain': '收益',
    'account-summary.transaction-record.txnType.bankCharge': '銀行手續費',
    'account-summary.transaction-record.txnType.settlement': '結賬',
    'account-summary.transaction-record.txnType.auctionRecoveryAmount':
        '資產款項取回',
    'account-summary.transaction-record.txnType.depositRounding': '存款-湊整',
    'account-summary.transaction-record.txnType.deposit': '存款',
    'account-summary.transaction-record.txnType.withdraw': '提款',
    'account-summary.transaction-record.txnType.spvServiceFee': 'SPV服務費',

    // Deposit Withdrawal Requests
    'account-summary.deposit-withdrawal-request.title': '存款 / 提款要求',
    'account-summary.deposit-withdrawal-request.requestDate': '建立日期',
    'account-summary.deposit-withdrawal-request.requestType': '類別',
    'account-summary.deposit-withdrawal-request.requestType.withdraw': '提款',
    'account-summary.deposit-withdrawal-request.requestType.deposit': '存款',
    'account-summary.deposit-withdrawal-request.requestType.spvServiceFee': 'SPV服務費',
    'account-summary.deposit-withdrawal-request.requestType.inExchangeDeposit':
        '外幣轉換',
    'account-summary.deposit-withdrawal-request.requestAmount': '金額',
    'account-summary.deposit-withdrawal-request.status': '狀態',
    'account-summary.deposit-withdrawal-request.status.approved': '已核准',
    'account-summary.deposit-withdrawal-request.status.rejected': '不獲批',
    'account-summary.deposit-withdrawal-request.status.pending': '待批',
    'account-summary.deposit-withdrawal-request.completeDate': '完成日期',
    'account-summary.deposit-withdrawal-request.placeholder.txnType': '類別',
    'account-summary.deposit-withdrawal-request.csv.requestDate': '建立日期',
    'account-summary.deposit-withdrawal-request.csv.requestType': '類別',
    'account-summary.deposit-withdrawal-request.csv.requestAmount': '金額',
    'account-summary.deposit-withdrawal-request.csv.status': '狀態',
    'account-summary.deposit-withdrawal-request.csv.completeDate': '完成日期',

    // Asset Portfolio Overview
    'assetsManagement.portfolio.title': '資產組合概覽',
    'assetsManagement.portfolio.caption': '圖像化您的資產分配',
    'assetsManagement.portfolio.message':
        '如果選擇多於一種貨幣，將會轉成美元顯示。',
    'assetsManagement.portfolio.csv.sellerNo': '客戶編號',
    'assetsManagement.portfolio.csv.currency': '貨幣',
    'assetsManagement.portfolio.csv.amount': '金額',

    // Asset - Awaiting Repayment
    'assetsManagement.awaiting-repayment.title': '資產 - 待付款應收賬款',
    'assetsManagement.awaiting-repayment.assetNumber': '資產編號',
    'assetsManagement.awaiting-repayment.advanceAmount': '匯款金額',
    'assetsManagement.awaiting-repayment.currency': '貨幣',
    'assetsManagement.awaiting-repayment.credit-enhancementList': '增信',
    'assetsManagement.awaiting-repayment.sellerNo': '賣方編號',
    'assetsManagement.awaiting-repayment.netGain': '淨收益',
    'assetsManagement.awaiting-repayment.receivedNetGain': '淨收入總值',
    'assetsManagement.awaiting-repayment.outstandingNetGain': '預期淨收益',
    'assetsManagement.awaiting-repayment.netReturn': '淨收益年利率',
    'assetsManagement.awaiting-repayment.advanceDate': '付款日',
    'assetsManagement.awaiting-repayment.lateDays': '遲還日數',
    'assetsManagement.awaiting-repayment.status': '狀態',
    'assetsManagement.awaiting-repayment.subAssetNo': '資產部分編號',
    'assetsManagement.awaiting-repayment.debtDuration': '為期',
    'assetsManagement.awaiting-repayment.dueDate': '到期日',
    'assetsManagement.awaiting-repayment.remitted-amount': '已還款金額',
    'assetsManagement.awaiting-repayment.outstanding-amount': '未付金額',
    'assetsManagement.awaiting-repayment.csv.assetNo': '資產編號',
    'assetsManagement.awaiting-repayment.csv.sellerNo': '客戶編號',
    'assetsManagement.awaiting-repayment.csv.credit-enhancement': '增信',
    'assetsManagement.awaiting-repayment.csv.obligorName': '付款方',
    'assetsManagement.awaiting-repayment.csv.currency': '貨幣',
    'assetsManagement.awaiting-repayment.csv.advanceAmount': '投標本金',
    'assetsManagement.awaiting-repayment.csv.grossGain': '總收益',
    'assetsManagement.awaiting-repayment.csv.outstandingGrossGain': '預期總收益',
    'assetsManagement.awaiting-repayment.csv.qupitalFee': '投資者佣金',
    'assetsManagement.awaiting-repayment.csv.netGain': '淨收益',
    'assetsManagement.awaiting-repayment.csv.receivedNetGain': '淨收入總值',
    'assetsManagement.awaiting-repayment.csv.outstandingNetGain': '預期淨收益',
    'assetsManagement.awaiting-repayment.csv.grossReturn': '總收益年利率',
    'assetsManagement.awaiting-repayment.csv.netReturn': '淨收益年利率',
    'assetsManagement.awaiting-repayment.csv.advanceDate': '付款日',
    'assetsManagement.awaiting-repayment.csv.dueDate': '到期日',
    'assetsManagement.awaiting-repayment.csv.remittedDate': '匯款日期',
    'assetsManagement.awaiting-repayment.csv.lostDeclarationDate':
        '損失聲明日期',
    'assetsManagement.awaiting-repayment.csv.recoverAmount': '取回金額',
    'assetsManagement.awaiting-repayment.csv.lateDays': '遲還日數 (天)',
    'assetsManagement.awaiting-repayment.csv.debtDuration': '為期 (日)',
    'assetsManagement.awaiting-repayment.csv.isInsured': '受保應收賬款',
    'assetsManagement.awaiting-repayment.csv.isObligorNotified': '通知付款方',
    'assetsManagement.awaiting-repayment.csv.status': '狀態',
    'assetsManagement.awaiting-repayment.csv.remitted-amount': '已還款金額',
    'assetsManagement.awaiting-repayment.csv.outstanding-amount': '未付金額',
    'assetsManagement.awaiting-repayment.tooltip.funder-flow-control': '資金流控制',
    'assetsManagement.awaiting-repayment.tooltip.inventory-control': '控貨',

    // Asset - Completed Repayment
    'assetsManagement.completed-repayment.title': '資產 - 全部競投',
    'assetsManagement.completed-repayment.assetNumber': '資產編號',
    'assetsManagement.completed-repayment.advanceAmount': '匯款金額',
    'assetsManagement.completed-repayment.currency': '貨幣',
    'assetsManagement.completed-repayment.credit-enhancementList': '增信',
    'assetsManagement.completed-repayment.sellerNo': '賣方編號',
    'assetsManagement.completed-repayment.netGain': '淨收益',
    'assetsManagement.completed-repayment.receivedNetGain': '淨收入總值',
    'assetsManagement.completed-repayment.outstandingNetGain': '預期淨收益',
    'assetsManagement.completed-repayment.netReturn': '淨收益年利率',
    'assetsManagement.completed-repayment.advanceDate': '付款日',
    'assetsManagement.completed-repayment.remittedDate': '匯款日期',
    'assetsManagement.completed-repayment.remittance.remittedDate': '匯款日期',
    'assetsManagement.completed-repayment.lateDays': '遲還日數',
    'assetsManagement.completed-repayment.status': '狀態',
    'assetsManagement.completed-repayment.subAssetNo': '資產部分編號',
    'assetsManagement.completed-repayment.debtDuration': '為期',
    'assetsManagement.completed-repayment.dueDate': '到期日',
    'assetsManagement.completed-repayment.remittance': '匯款紀錄',
    'assetsManagement.completed-repayment.detail': '詳情',
    'assetsManagement.completed-repayment.principalAmount': '本金',
    'assetsManagement.completed-repayment.remitted-amount': '已還款金額',
    'assetsManagement.completed-repayment.outstanding-amount': '未付金額',
    'assetsManagement.completed-repayment.csv.assetNo': '資產編號',
    'assetsManagement.completed-repayment.csv.sellerNo': '客戶編號',
    'assetsManagement.completed-repayment.csv.credit-enhancement': '增信',
    'assetsManagement.completed-repayment.csv.obligorName': '付款方',
    'assetsManagement.completed-repayment.csv.currency': '貨幣',
    'assetsManagement.completed-repayment.csv.advanceAmount': '投標本金',
    'assetsManagement.completed-repayment.csv.principalAmount': '本金',
    'assetsManagement.completed-repayment.csv.grossGain': '總收益',
    'assetsManagement.completed-repayment.csv.qupitalFee': '投資者佣金',
    'assetsManagement.completed-repayment.csv.netGain': '淨收益',
    'assetsManagement.completed-repayment.csv.receivedNetGain': '淨收入總值',
    'assetsManagement.completed-repayment.csv.outstandingNetGain': '預期淨收益',
    'assetsManagement.completed-repayment.csv.grossReturn': '總收益年利率',
    'assetsManagement.completed-repayment.csv.netReturn': '淨收益年利率',
    'assetsManagement.completed-repayment.csv.advanceDate': '付款日',
    'assetsManagement.completed-repayment.csv.dueDate': '到期日',
    'assetsManagement.completed-repayment.csv.remittedDate': '匯款日期',
    'assetsManagement.completed-repayment.csv.lostDeclarationDate':
        '損失聲明日期',
    'assetsManagement.completed-repayment.csv.recoverAmount': '取回金額',
    'assetsManagement.completed-repayment.csv.lateDays': '遲還日數 (天)',
    'assetsManagement.completed-repayment.csv.debtDuration': '為期 (日)',
    'assetsManagement.completed-repayment.csv.isInsured': '受保應收賬款',
    'assetsManagement.completed-repayment.csv.isObligorNotified': '通知付款方',
    'assetsManagement.completed-repayment.csv.status': '狀態',
    'assetsManagement.completed-repayment.csv.remitted-amount': '已還款金額',
    'assetsManagement.completed-repayment.csv.outstanding-amount': '未付金額',
    'assetsManagement.completed-repayment.tooltip.funder-flow-control': '資金流控制',
    'assetsManagement.completed-repayment.tooltip.inventory-control': '控貨',
    'assetsManagement.live-asset.title': '資產 - 競投中',

    // Report
    'assetsManagement.statement.title': '結單',
    'assetsManagement.statement.select-date-range': '選擇日期範圍',
});

export { BalanceAssetEN, BalanceAsset_ZH_TW };
